var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('app-top-bar',{attrs:{"menu":_vm.menu,"color":'linear-gradient(135deg, #1E3C72 0%, #2A5298 100%)',"moduleName":'MODULE SELECTOR'}}),_c('v-main',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }